import React, { useEffect, useState } from 'react';

import { ERROR_LEVELS, SENTRY_EPPO } from 'services/Sentry/constants';

import sentry from 'services/Sentry/SentryInstance';

import { initEppo } from './client';

export const EppoGate: React.FC<React.PropsWithChildren<{ fallback?: React.ReactNode }>> = ({
    children,
    fallback = null,
}) => {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        initEppo()
            .catch((err) => {
                sentry.logError(err, SENTRY_EPPO, ERROR_LEVELS.ERROR);
            })
            .finally(() => setReady(true));
    }, []);

    return ready ? <>{children}</> : <>{fallback}</>;
};
